import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@/components/HideIllustrationsExternal'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import { DeviceErrorModalProps } from './types'
import { useRedirectByCouncil } from '@/modules/Attendance/submodules/Scheduled/hooks/useRedirectByCouncil'

const DeviceErrorModal: FunctionComponent<DeviceErrorModalProps> = props => {
  const {
    consultationId,
    canReschedule,
    professionalType,
    professionalId,
    tokenId,
  } = props

  const { closeModal } = useModalContext()
  const { redirectToAppointmentScheduling } = useRedirectByCouncil()
  const history = useHistory()

  const styles = useStyles()

  const handleConfirm = () => {
    if (consultationId) {
      history.push(`/meus-atendimentos/atendimento/${consultationId}`)

      return
    }

    history.push('/meus-atendimentos')
  }

  const handleReschedule = () => {
    redirectToAppointmentScheduling({
      professionalType,
      professionalId,
      token: tokenId,
    })
  }

  return (
    <Modal
      id="DEVICE_ERROR"
      onDismiss={closeModal}
      primaryActionLabel="Ir para consultas"
      primaryAction={handleConfirm}
      secondaryActionLabel={canReschedule ? 'Reagendar' : null}
      secondaryAction={handleReschedule}
      size={canReschedule ? 572 : 472}
    >
      <div css={styles.illustrationWrapper}>
        <Illustration name="user-phonesignal-error" width="172px" />
      </div>
      <Text css={styles.caption}>
        O aparelho apresenta problemas que podem prejudicar sua conversa com o
        profissional.
      </Text>
    </Modal>
  )
}

export { DeviceErrorModal }
